import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'

dayjs.extend(utc)
dayjs.extend(timezone)

/** IANA zone for a station from the loaded station configs, with a fallback. */
export function stationTimezone(stationConfigs, stationName, fallback = null) {
  const wanted = (stationName ?? '').toLowerCase()
  const station = (stationConfigs ?? []).find((s) => (s.station_name ?? '').toLowerCase() === wanted)
  return station?.settings?.tz ?? fallback ?? dayjs.tz.guess()
}

/**
 * Cross-workspace contexts show times in the SOURCE station's zone and always
 * carry the zone abbreviation (project timezone standard).
 */
export function formatInStationTime(value, tz) {
  if (!value) return ''
  return dayjs.utc(value).tz(tz).format('MMM D, YYYY h:mm A z')
}

/** Upper-cased source station for a copy that crossed workspaces, else null. */
export function sourceStationLabel(asset) {
  if (!asset?.is_cross_workspace_copy || !asset?.source_station_name) return null
  return asset.source_station_name.toUpperCase()
}
